import { Field, TextInput, TextArea, SectionCard } from "./_shared";

export default function EditCookieConsent({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <SectionCard title="Banner de Cookies (LGPD)">
      <div className="space-y-5">
        <Field label="Texto do banner"><TextArea value={value.text} onChange={(v) => set("text", v)} rows={3} testId="cookie-text-input" /></Field>
        <div className="grid sm:grid-cols-2 gap-3">
          <Field label="Texto do botão Aceitar"><TextInput value={value.acceptLabel} onChange={(v) => set("acceptLabel", v)} testId="cookie-accept-label" /></Field>
          <Field label="Texto do botão Recusar"><TextInput value={value.declineLabel} onChange={(v) => set("declineLabel", v)} testId="cookie-decline-label" /></Field>
        </div>
        <Field label="URL da política de privacidade"><TextInput value={value.policyUrl} onChange={(v) => set("policyUrl", v)} testId="cookie-policy-url" /></Field>
      </div>
    </SectionCard>
  );
}
